<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="전체 다운로드 신청 내역"
      desc=""
    ></admin-filter>

    <!-- 탭 2 -->
    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 nextPageName="nopage"
                 :table_width="1400"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </div>

      <!-- 번호 -->
      <div slot="index" slot-scope="props">{{ props.item.index }}</div>

      <!-- 상품 주문번호 -->
      <div slot="order_num" slot-scope="props">
        <div @click="clickDetail(props.item.id)"
             class="unselect"
             style="text-decoration: underline">{{ props.item.order_num }}</div>
      </div>

      <!-- 날짜 -->
      <div slot="created_time" slot-scope="props">{{ props.item.created_time }}</div>

      <!-- 주문자 -->
      <div slot="order" slot-scope="props">{{ props.item.name }}</div>

      <!-- 주문 상품 -->
      <div slot="order_product" slot-scope="props">
        <div style="text-align:left;width:100%">
          <div v-for="(op, idx) in props.item.order_product"
               :key="`op-${idx}`"
               :class="{'line-divide': idx>1}">
            <div>{{ op.product.name }}</div>
            <div v-for="(option, option_idx) in op.option" :key="`option-${option_idx}`">
              <div>{{ option.name }} <span v-if="option.price>0">/ {{ option.price | currency }}</span></div>
            </div>
          </div>
        </div>
        <!--<div style="text-align: left">
          <div>{{ props.item.product.name }}</div>
          <div v-for="(op, idx) in props.item.option"
               :key="`option-${idx}`">
            <div>옵션: {{ op.name }} / {{ op.price | currency }}</div>
          </div>

        </div>-->
      </div>

      <!-- 총 상품 금액-->
      <div slot="product_price" slot-scope="props">{{ props.item.product_price | currency }}</div>

      <!-- 할인 금액 -->
      <div slot="discount_price" slot-scope="props">{{ props.item.discount_price | currency }}</div>

      <!-- 전체 금액-->
      <div slot="total_price" slot-scope="props">{{ props.item.total_price | currency }}</div>

      <!-- 파트너명 -->
      <div slot="partner" slot-scope="props">{{ props.item.partner }}</div>

      <!-- 결제 방법 -->
      <div slot="pay_type" slot-scope="props">{{ props.item.pay_type_kor }}</div>

      <div slot="status_kor" slot-scope="props">
        {{ props.item.order_product[0].status_kor }}
      </div>

      <!-- 일괄 처리 -->
      <div slot="spot">
        <div class="flex align-center" style="background-color: #eee; padding: 8px">
          <span>선택한 주문을</span>
          <span class="select" style="margin-left: 8px">
            <select v-model="status" @change="e=> status=e.target.value">
              <option value="" disabled selected>주문상태</option>
              <option :value="item.value" v-for="(item,idx) in status_arr" :key="'status-'+idx">{{ item.label }}</option>
            </select>
          </span>
          <button class="button" style="margin-left:8px" @click="clickChange">일괄처리</button>
        </div>
      </div>
    </admin-table>

    <modal name="cancelModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="삭제" :useTab="false" class="lp-modal-wrapper">
        <div>결제취소 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelModal')">취소</button>
          <button class="button is-primary" @click="confirmModal(900)">확인</button>
        </div>
      </admin-box-item>
    </modal>
  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import CommerceMixin from "@/mixins/CommerceMixin"

  export default {
    name: 'DownloadNew',
    components: {LpCheckBool},
    mixins: [
      CommerceMixin
    ],
    data() {
      return {}
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.initializing('order_new', 'commerce/order?status=100', `DownloadNew`);
      },
      getDataFromServer() {
        this.getData();
      },
      totalPrice(item) {
        let total_price = 0;
        for(let i=0; i<this.tableItems.length; i++){
          if(this.tableItems[i].order === item.order) {
            total_price += this.tableItems[i].total_price;
          }
        }
        return total_price;
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .admin-table td > div
    -webkit-line-clamp unset
    text-overflow unset

  .line-divide
    border-bottom 1px solid #dbdbdb
    margin-bottom 12px
    padding-bottom 12px

  .line-divide:last-child
    border-bottom 0
    margin-bottom 0
    padding-bottom 0


</style>
